import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './components/App';
import LeadershipCompsPage from './components/leadership-comps/LeadershipCompsPage';
import LeadershipCompsSectionPage from './components/leadership-comps/LeadershipCompsSectionPage';
import FunctionalSkillsPage from './components/functional-skills/functionalSkillsPage';
import CourseResourcesPage from './components/course-resources/page';
import HowToPage from './components/how-to/page';
import ContributePage from './components/contribute/page';
import UsefulSitesPage from './components/useful-sites/page';

export default (
  <Route path="/" component={App}>
    <IndexRoute component={LeadershipCompsPage} />
    <Route path="leadership-comps" component={LeadershipCompsPage}/>
    <Route path="leadership-comps/:section" component={LeadershipCompsSectionPage}/>
    <Route path="functional-skills" component={FunctionalSkillsPage}/>
    <Route path="course-resources" component={CourseResourcesPage} />
    <Route path="how-to" component={HowToPage} />
    <Route path="contribute" component={ContributePage} />
    <Route path="useful-sites" component={UsefulSitesPage} />
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/